<script setup lang="ts">
const user = process.server ? ref(null) : useUser()
</script>

<template>
  <slot v-if="user" :user="user" />
</template>
